import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteInSystemNotification } from '../../../../actions';

class InSystemNotificationDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteInSystemNotification, inSystemNotificationId } =
      this.props;
    dispatchDeleteInSystemNotification({ inSystemNotificationId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

InSystemNotificationDeleteButton.propTypes = {
  inSystemNotificationId: PropTypes.number.isRequired,
  dispatchDeleteInSystemNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteInSystemNotification: deleteInSystemNotification,
};

export default connect(
  null,
  mapDispatchToProps,
)(InSystemNotificationDeleteButton);
